import { ChangeDetectionStrategy, Component, Input, Pipe, PipeTransform } from "@angular/core";
import { ViewService } from "core/view.service";
import { Observable } from "rxjs";
import { Group } from "common/collapsible-groups/collapsible-groups.component";
import { BaseComponent } from "process/view/base.component";
import { ComponentService } from "process/view/component.service";
import { SlotService } from "common/slot.service";
@Component({
	selector: "stages-tailoring-conditions-grouped",
	templateUrl: "./tailoring-conditions-grouped.component.html",
	styleUrls: ["./tailoring-conditions-grouped.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TailoringConditionsGroupedComponent extends BaseComponent {
	@Input() translateNone?: string;

	selfElement$: Observable<stages.process.ProcessTreeItem>;

	constructor(private viewService: ViewService, componentService: ComponentService, slotService?: SlotService) {
		super(componentService, slotService);
		this.selfElement$ = this.viewService.awaitSelfElementObservable();
	}
}

@Pipe({
	name: "dependentAsGroup",
	pure: true,
})
export class DependentAsGroupPipe implements PipeTransform {
	transform(dependentElements: stages.process.ViewableDependentElement[] | undefined, _args?: unknown): Group[] {
		if (!dependentElements) {
			return [];
		}
		return dependentElements.map((e) => {
			return {
				ident: e.identity,
				name: e.label,
				type: e.type,
				element: e,
				showEmpty: false,
				getMemberCount() {
					return e.tailoringConditions ? e.tailoringConditions.length : 0;
				},
			};
		});
	}
}

@Pipe({
	name: "hasDependentTailoringConditions",
	pure: true,
})
export class HasDependentTailoringConditionsPipe implements PipeTransform {
	transform(dependentElements: stages.process.ViewableDependentElement[] | undefined, _args?: unknown): boolean {
		if (!dependentElements || dependentElements.length === 0) {
			return false;
		}
		for (const dependent of dependentElements) {
			if (dependent.tailoringConditions?.length) {
				return true;
			}
		}
		return false;
	}
}
